module.exports = {
      id: "personalise-usage",
      viewBox: "0 0 14.128 12.555",
      url: "/" + "sprite-a5f842c290447276eba09a9bdedabd59.svg#personalise",
      toString: function () {
        return this.url;
      }
    }